import type { JSX } from 'react';

export function ContactsUnavailableNotice({ isLoading }: { isLoading: boolean }): JSX.Element {
  if (isLoading) {
    return (
      <p className="bg-muted/50 p-4 text-sm text-muted-foreground">
        Loading the reference contacts...
      </p>
    );
  }
  return (
    <p className="bg-muted/50 p-4 text-sm text-destructive">
      Could not load the reference contacts.
    </p>
  );
}
